// interface FormData {
// 	name: string;
// 	email: string;
// 	contactNo: string;
// 	description: string;
// }

// interface Errors {
// 	name?: string;
// 	email?: string;
// 	contactNo?: string;
// 	description?: string;
// }

// const validate = (values: FormData): Errors => {
// 	const errors: Errors = {};

// 	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// 	// const contactPattern = /^[0-9]{10}$/;

// 	if (!values.name) {
// 		errors.name = 'Name is required';
// 	}

// 	if (!values.email) {
// 		errors.email = 'Email is required';
// 	} else if (!emailPattern.test(values.email)) {
// 		errors.email = 'Invalid email address';
// 	}

// 	if (!values.contactNo) {
// 		errors.contactNo = 'Contact number is required';
// 	} else if (!/^\d{10}$/.test(values.contactNo)) {
// 		errors.contactNo = 'Contact number must be exactly 10 digits';
// 	}

// 	if (!values.description) {
// 		errors.description = 'Description is required';
// 	}

// 	return errors;
// };

// export default validate;

interface FormData {
	name: string;
	email: string;
	contactNo: string;
	description: string;
	location: string;
}

interface Errors {
	name?: string;
	email?: string;
	contactNo?: string;
	description?: string;
	location?: string;
}

const validate = (values: FormData): Errors => {
	const errors: Errors = {};

	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	// const contactPattern = /^[0-9]{10}$/;

	if (!values.name) {
		errors.name = 'Name is required';
	}

	if (!values.email) {
		errors.email = 'Email is required';
	} else if (!emailPattern.test(values.email)) {
		errors.email = 'Invalid email address';
	}

	if (!values.contactNo) {
		errors.contactNo = 'Contact number is required';
	} else if (!/^\d{10}$/.test(values.contactNo)) {
		errors.contactNo = 'Contact number must be exactly 10 digits';
	}

	if (!values.description) {
		errors.description = 'Description is required';
	}
	if (!values.location) {
		errors.location = 'Location is required';
	}

	return errors;
};

export default validate;
